module.exports = __webpack_public_path__ + "static/img/rz(1).ac69ae97.jpeg";